import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../../types/types';
import { openBoardSettings } from '../../../../../../../base/effects/openBoardSettings';
import { SegmentBoardSettingsSourceValue } from '../../../../../../../../../middlewares/segment/trackEntities/boardEvents';
import {
    EBoardSetting
} from '../../../../../../../aside_panel/boardDetails/details/TabDetails/components/TabDetails/types';

export const onOpenSettings = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(openBoardSettings(EBoardSetting.COLOR_LABELS, SegmentBoardSettingsSourceValue.NEW_CARD_COLOR_TAGS));
    };

    return action;
};
